import { Button } from '@instructure/ui-buttons/es/Button';
import { Checkbox } from '@instructure/ui-checkbox';
import { Modal } from '@instructure/ui-modal';
import { Table } from '@instructure/ui-table';
import { Pagination } from '@instructure/ui-pagination';
import { CondensedButton } from '@instructure/ui-buttons';
import { Link } from '@instructure/ui-link';
import { Spinner } from '@instructure/ui-spinner';
import { Flex } from '@instructure/ui-flex';
import React, { useEffect, useState, useCallback } from "react";
import { instance } from '../axios';
import '../css/styles.css';

const Recommend = ({ open, bsId, ghId, onCancel, onSubmit, selectedIdList }) => {
  const [selectList, setSelected] = useState([]);
  const [dataList, setDataList] = useState([]);
  const [rows, setRows] = useState([]);
  const [ascending, setAscending] = useState(true);
  const [page, setPage] = useState(0);
  const [loading, setLoading] = useState(true);

  const parseYear = (yearStr) => new Date(yearStr).getFullYear();
  const compareYearAscDate = useCallback((a, b) => parseYear(a.cbrq) - parseYear(b.cbrq), []);
  const compareYearDescDate = (a, b) => parseYear(b.cbrq) - parseYear(a.cbrq);

  useEffect(() => {
    if (open) {
      setLoading(true);
      instance({
        method: 'post',
        url: `recommendedReference`,
        data: {
          bsid: bsId,
          gh: ghId,
        },
      })
        .then((res) => {
          setLoading(false);
          if (res.data.code === 0 && res.data.message === "SUCCESS") {
            const arr = res?.data?.data?.map((e, i) => ({ id: i, ...e })) || [];
            setDataList(arr);
            setAscending(true);
            setRows(arr.slice(page * 10, (page + 1) * 10).sort(compareYearAscDate));
          }
        })
        .catch((error) => {
          setLoading(false);
          console.log(error);
        });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bsId, ghId, open]);

  const columns = [
    {
      id: 'resource',
      text: '类型',
      width: '5%',
      textAlign: 'start',
    },
    {
      id: 'recommendType',
      text: '推荐依据',
      width: '10%',
      textAlign: 'start',
    },
    {
      id: 'jcmc',
      text: '名称',
      width: '20%',
      textAlign: 'start',
    },
    {
      id: 'zzxm',
      text: '作者',
      width: '15%',
      textAlign: 'start',
    },
    {
      id: 'cbdw',
      text: '出版社',
      width: '10%',
      textAlign: 'start',
    },
    {
      id: 'isbn',
      text: 'ISBN',
      width: '10%',
      textAlign: 'start',
    },
    {
      id: 'cbrq',
      text: '出版年',
      width: '10%',
      textAlign: 'start',
    },
    {
      id: 'action',
      text: '操作',
      width: '10%',
      textAlign: 'center',
      renderCell: rating => (
          rating?.url ? (
            <Link href={rating.url} as="a" target="_blank">
              <CondensedButton>
                查看全文
              </CondensedButton>
            </Link>
          ) : (
            <CondensedButton interaction="disabled">查看全文</CondensedButton>
          )
      ),
    },
  ];

  const handleSort = () => {
    setAscending(!ascending);
    setRows(rows.sort(!ascending ? compareYearAscDate : compareYearDescDate));
  };

  const handleChangePage = (page) => {
    setPage(page);
    setRows(dataList.slice(page * 10, (page + 1) * 10).sort(ascending ? compareYearAscDate : compareYearDescDate));
  };

  const mapTableTow = (row, id) => {
    if (id === 'recommendType') {
      return row[id] === 1 ? '世界一流课程' : '同类课程';
    } else {
      return row[id];
    }
  };

  const handleClose = () => {
    setSelected([]);
    setDataList([]);
    setPage(0);
    setRows([]);
  };

  const allSelected = selectList?.length === dataList?.length && dataList?.length;
  const direction = ascending ? "ascending" : "descending";

  return (
    <Modal open={open} size="large" label="Modal Dialog: 图书馆推荐的教参" onExited={handleClose}>
      <Modal.Header>
        <p
          style={{
            fontSize: "18px",
            margin: "0px",
            fontWeight: "700",
          }}
        >
          图书馆推荐的教参<span style={{ color: 'red' }}>（书籍）</span>
        </p>
      </Modal.Header>
      <Modal.Body>
        <Table caption="table">
          <Table.Head>
            <Table.Row>
              <Table.ColHeader id="select" width="10%">
                <Checkbox
                  label=""
                  onChange={() => {
                    setSelected(allSelected ? [] : dataList?.map(e => e.id) );
                  }}
                  checked={allSelected}
                  indeterminate={selectList.length > 0 && selectList?.length !== dataList?.length}
                />
              </Table.ColHeader>
              {(columns || []).map(({ id, text, width, textAlign }) => (
                <Table.ColHeader
                  key={id}
                  id={id}
                  width={width}
                  textAlign={textAlign}
                  onRequestSort={id === 'cbrq' && handleSort}
                  sortDirection={id === 'cbrq' ? direction : "none"}
                >
                  {text}
                </Table.ColHeader>
              ))}
            </Table.Row>
          </Table.Head>
          <Table.Body>
            {(rows || []).map((row) => {
              const rowSelected = selectList.includes(row.id);
              return (
                <Table.Row key={row.id}>
                  <Table.RowHeader>
                    {!selectedIdList.includes(row.id) &&
                      (<Checkbox
                        label=""
                        onChange={() => {
                          if (rowSelected) {
                            setSelected(selectList.filter(e => e !== row.id));
                          } else {
                            setSelected([...selectList, row.id]);
                          }
                        }}
                        checked={rowSelected}
                      />)
                    }
                  </Table.RowHeader>
                  {columns.map(({ id, renderCell, textAlign }) => (
                    <Table.Cell key={id} id={id} textAlign={textAlign}>
                      {renderCell ? renderCell(row) : mapTableTow(row, id)}
                    </Table.Cell>
                  ))}
                </Table.Row>
              );
            })}
          </Table.Body>
        </Table>

        {
          loading ? <Flex textAlign="center" justifyItems="center" height="200px">
                      <Flex.Item>
                        <Spinner renderTitle="Loading" size="small" />
                        <p style={{ textAlign: 'center' }}>正在推荐，请稍候</p>
                      </Flex.Item>
                    </Flex>
                  : !dataList?.length
                    ? <p style={{ textAlign: 'center' }}>暂无推荐教参</p>
                    : ''
        }

        <Pagination
          variant="compact"
          labelNext="Next Page"
          labelPrev="Previous Page"
          margin="large"
        >
          {Array.from(Array(Math.ceil(dataList?.length / 10)), (item, index) => (
            <Pagination.Page
              key={index}
              onClick={() => handleChangePage(index)}
              current={index === page}
            >
              {index + 1}
            </Pagination.Page>
          ))}
        </Pagination>
      </Modal.Body>
      <Modal.Footer>
        <Button
          color="primary"
          margin="0 x-small 0 0"
          interaction={selectList.length ? "enabled" : "disabled"}
          onClick={() => {
            onSubmit(dataList?.filter(e => selectList.includes(e.id))?.map(({id, ...e}) => e));
          }}
        >
          确定
        </Button>
        <Button
          color="primary"
          onClick={() => {
            onCancel();
          }}
        >
          关闭
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
export default Recommend;
